import './IconedInputField.css';

export default function IconedInputField(props) {
    return (
        <div className="iconedInputField shadow">
           <input onBlur={props.onBlur} required={props.required} type={props.type} id={props.inputId} className="formField" placeholder={props.placeholder} name={props.name} value={props.value} onChange={props.onChange} checked={props.checked}/> <img src={props.image} alt="" id={props.imageId} onClick={props.onClickOnIcon}/>
        </div>
    )
}